__webpack_require__.p = "https://fr-fund-holdings-fe.dev.securitize.io/";